<div fxLayout="column" fxLayoutGap="5px">
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="flex-start center">
        <mat-form-field class="no-label" fxFlex="auto">
            <input [placeholder]="startDatePlaceholder" type="text" aria-label="Start date" matInput
                   [nbDatepicker]="datepickerStart" id="startDate"
                   [(ngModel)]="startDate" (ngModelChange)="startDateChanged()" readonly>
            <nb-datepicker #datepickerStart></nb-datepicker>
        </mat-form-field>

        <span>-</span>

        <mat-form-field class="no-label" fxFlex="auto">
            <input [placeholder]="endDatePlaceholder" aria-label="End date" matInput
                   [nbDatepicker]="datepickerEnd" id="endDate"
                   [(ngModel)]="endDate" (ngModelChange)="endDateChanged()" readonly>
            <nb-datepicker #datepickerEnd></nb-datepicker>
        </mat-form-field>
    </div>
</div>

